import { useEffect } from "react";
import Lenis from "lenis";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import Marquee from "@/components/site/Marquee";
import Gallery from "@/components/site/Gallery";
import Amenities from "@/components/site/Amenities";
import Sleeping from "@/components/site/Sleeping";
import Location from "@/components/site/Location";
import Booking from "@/components/site/Booking";
import RulesHost from "@/components/site/RulesHost";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";

export default function Home() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -70 }); }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Stats />
        <Marquee />
        <Gallery />
        <Amenities />
        <Sleeping />
        <Location />
        <Booking />
        <RulesHost />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}
